var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.214355 14.3571C0.214355 6.42791 6.64226 0 14.5715 0C22.5007 0 28.9286 6.42791 28.9286 14.3571C28.9286 22.2864 22.5007 28.7143 14.5715 28.7143C6.64226 28.7143 0.214355 22.2864 0.214355 14.3571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_245_667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1992 12.2609C23.2362 11.1906 23.0021 10.1283 22.5187 9.17264C22.1907 8.78051 21.7356 8.51588 21.2326 8.42487C19.1519 8.23608 17.0627 8.1587 14.9737 8.19306C12.8924 8.15714 10.8107 8.23202 8.73735 8.41739C8.32744 8.49196 7.9481 8.68423 7.64561 8.97074C6.97262 9.59139 6.89785 10.6532 6.82307 11.5505C6.71458 13.1639 6.71458 14.7827 6.82307 16.3961C6.8447 16.9011 6.9199 17.4024 7.0474 17.8916C7.13756 18.2693 7.31998 18.6187 7.57831 18.9086C7.88286 19.2103 8.27103 19.4135 8.69249 19.4918C10.3046 19.6908 11.929 19.7733 13.553 19.7386C16.1702 19.776 18.4658 19.7386 21.1802 19.5292C21.612 19.4557 22.0111 19.2522 22.3243 18.946C22.5336 18.7365 22.69 18.4802 22.7804 18.1982C23.0479 17.3776 23.1792 16.5188 23.1693 15.6558C23.1992 15.237 23.1992 12.7096 23.1992 12.2609ZM13.2838 16.1044V11.4758L17.7106 13.8013C16.4693 14.4893 14.8317 15.2669 13.2838 16.1044Z",
    fill: "#1E2132"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_245_667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.9464,
    height: 17.9464,
    fill: "white",
    transform: "translate(6 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/yt.aae2740a8f93413e5bbf61facb000c2c.svg";
export { ForwardRef as ReactComponent };